import HeaderTitleContent from '../../../common/components/atom/HeaderTitleContent/HeaderTitleContent'
import CreateUpdateMinigridFormPresenter from '../../../features/minigrid/components/CreateMinigrid/CreateUpdateMinigridForm/CreateUpdateMinigridFormPresenter'

export default function CreateMinigridPage() {
  return (
    <>
        <HeaderTitleContent withGoBackBtn goBackBtnLabel="Tous les minigirds" goBackTo='/main/minigrid' >Nouveau Minigrid</HeaderTitleContent>
        <div>
            <CreateUpdateMinigridFormPresenter />
        </div>
    </>
  )
}
